<template>
  <el-dialog 
    :visible.sync="visible"
    class="guide_dialog"
    width="600px">
    <h5 slot="title" class="dialog_title fc">离成功投放广告还剩3步</h5>
    <el-carousel
      height="300px"
      :autoplay="false"
      indicator-position="outside"
      :loop="false">
      <el-carousel-item class="c_item">
        <img :src="image1" class="item_image">
        <h6>完善信息</h6>
        <p>您也可以前往“账号中心-客户信息”进行操作</p>
      </el-carousel-item>
      <el-carousel-item class="c_item">
        <img :src="image2" class="item_image">
        <h6>补全资质</h6>
        <p>您也可以前往“账号中心-客户信息”进行操作</p>
      </el-carousel-item>
      <el-carousel-item class="c_item">
        <img :src="image3" class="item_image">
        <h6>广告投放</h6>
        <p>您也可以前往“账号中心-客户信息”进行操作</p>
      </el-carousel-item>
    </el-carousel>
    <div slot="footer" class="fc">
      <ad-button class="sure_btn" width="120" height="30" @click="goAccount">完善信息</ad-button>
    </div>
  </el-dialog>
</template>

<script>
import image1 from '@/assets/Group@2x.png'
import image2 from '@/assets/Group@2x-2.png'
import image3 from '@/assets/Group@2x-3.png'

export default {
  name: 'GuideDialog',
  data () {
    return {
      visible: false,
      image1,
      image2,
      image3
    }
  },
  computed: {
    adUser () {
      return this.$store.state.customer.userInfo
    },
    needComplete () {
      if (this.adUser && this.adUser.id) { // 有用户信息
        return !this.adUser.customerId // 客户ID为0或不存在(即游客客户<=>只注册用户但未完善客户资料)
      }
      return false // 还未请求到用户信息
    }
  },
  watch: {
    needComplete: {
      immediate: true,
      handler (v) {
        if (v && this.$route.name !== 'accountInfo') {
          this.visible = true
        } else {
          this.visible = false
        }
      }
    },
  },
  methods: {
    goAccount () {
      this.visible = false
      this.$router.push({ name: 'accountInfo'})
    }
  }
}
</script>

<style lang="sass" rel="stylesheet">
.guide_dialog
  ::v-deep.el-dialog__header
    border-bottom: 1px solid #e9e9e9
  ::v-deep.el-dialog__footer
    padding: 0 0 15px 0
    border-top: 1px solid #e9e9e9
  ::v-deep.el-carousel__indicator button
    padding: 0
    width: 8px 
    height: 8px
    border-radius: 4px 
    border: 1px solid #d4d4d4
  ::v-deep.el-dialog__body
    padding: 0 0 10px 0 !important
  ::v-deep.is-active button
      background-color: #ff3973 !important
      border-color: #ff3973
.dialog_title
  color: #282729
  font-size: 18px
  font-weight: 600
  line-height: 25px
.item_image
  display: block
  margin: 50px auto 20px
  width: 280px
  height: 160px
.c_item
  text-align: center
  h6
    color: #282729
    font-size: 16px
    line-height: 22px
    margin-bottom: 10px
  &>p
    color: #999
    font-size: 14px
    line-height: 20px
.sure_btn
  margin: 15px auto 0 !important
  font-size: 14px !important
</style>